import { Tooltip, tooltipClasses } from "@mui/material";
import { styled } from "@mui/system";

export const OcCustomTooltip = styled(
  ({
    className,
    ...props
  }: React.ComponentProps<typeof Tooltip> & { className?: string }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ),
)(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#212121",
    color: "#FFFFFF",
    maxWidth: "400px",
    fontSize: "16px",
  },
}));

export default OcCustomTooltip;
